<template>
<div class="container">  
  <div class="row justify-content-center">      
    <div class="col-md-12 col-lg-8 col-12">            
      <div class="highlight-text my-5">
        <div class="line-destacado"></div>
        <div class="summary-text">
          <h2 v-html="cardText.text"></h2>
        </div>        
        <div class="line-destacado"></div>
      </div>
    </div>
  </div>    
</div>
</template>

<style>
  .line-destacado {
    width: 100%;
    max-width: 320px;
    height: 2px;
    margin: 30px auto;
    background-color: #e3e3e3;
  }
</style>

<script>  
export default {
  name: 'SingleCard',
  props: {
    cardText: Object
  }

}
</script>